import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import * as React from 'react';
import styled from 'styled-components';
import validProp from '@emotion/is-prop-valid';
var StyledIcon = React.forwardRef(function (props, ref) {
  var title = props.title,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["title", "size"]);

  var iconProps = {
    viewBox: '0 0 16 16',
    height: props.height !== undefined ? props.height : size,
    width: props.width !== undefined ? props.width : size,
    // @ts-ignore - aria is not always defined on SVG in React TypeScript types
    'aria-hidden': title == null ? 'true' : undefined,
    focusable: 'false',
    role: title != null ? 'img' : undefined,
    "fill": "currentColor"
  };
  var svgProps = Object.keys(otherProps).reduce(function (p, k) {
    if (validProp(k)) {
      p[k] = otherProps[k];
    }

    return p;
  }, {});
  return React.createElement("svg", _extends({}, iconProps, svgProps, {
    ref: ref
  }), title && React.createElement("title", {
    key: "Google2-title"
  }, title), React.createElement("path", {
    d: "M14.5 0h-13C.675 0 0 .675 0 1.5v13c0 .825.675 1.5 1.5 1.5h13c.825 0 1.5-.675 1.5-1.5v-13c0-.825-.675-1.5-1.5-1.5zM8.119 14c-3.316 0-6-2.684-6-6s2.684-6 6-6c1.619 0 2.975.591 4.019 1.569L10.51 5.138c-.447-.428-1.225-.925-2.391-.925C6.069 4.213 4.4 5.91 4.4 8s1.672 3.787 3.719 3.787c2.375 0 3.266-1.706 3.403-2.588H8.119V7.143h5.666c.05.3.094.6.094.994C13.882 11.565 11.585 14 8.12 14z",
    key: "k0"
  }));
});
export var Google2 = styled(StyledIcon).withConfig({
  displayName: "Google2",
  componentId: "rc711f-0"
})(["display:inline-block;vertical-align:middle;overflow:hidden;"]);
Google2.displayName = 'Google2';
export var Google2Dimensions = {
  height: 16,
  width: 16
};